/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useRef, useState } from 'react';
//import { defualtTableProps } from '../variables'
import ClientInfo from './ClientInfo'
import { centerClient } from '../../shared/clients';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, RowClassParams, RowDoubleClickedEvent } from 'ag-grid-community';
import { AG_GRID_LOCALE_RU } from 'blick.react.aggrid';
import context, { localStorageKeys } from './context/shared';
import { findAccountNodeByLoginAndClient } from '../../utils/treeFunctions';
import { observer } from 'mobx-react-lite';
import { Skeleton } from '@mui/material';
import { useIsMobile } from '../shared';
import { BlickAgGrid } from 'blick.react.aggrid';
import { Account, Client, Device } from '../../shared/generated';

const columnNames = {
    rowNumber: 'row-number',
    login: 'Login',
    password: 'Password',
    devicesCount: 'devicesCount',
    unblockedCount: 'unblockedCount'
}

interface IAccountsTableRow extends Account {
    unblockedCount: number;
    devicesCount: number;
}

const getDefaultColumnWidth = (field) => {
    switch (field) {
        case columnNames.rowNumber:
            return 50;
        case columnNames.login:
            return 200;
        case columnNames.password:
            return 200;
        case columnNames.devicesCount:
            return 150;
        case columnNames.unblockedCount:
            return 200;
        default:
            return 150;
    }
}

const ClientView = observer(() => {
    const [data, setData] = useState<Account[]>([]);
    const [client, setClient] = useState<Client | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const { currentNode, setCurrentNode, clientsTreeData, setPendingScrollNodeKey, setClientAccounts, setShowClientSettings } = context;

    const onRowDoubleClicked = (e: RowDoubleClickedEvent<IAccountsTableRow>) => {
        if (e.node?.isRowPinned() || !e.data?.Login || !currentNode)
            return;
        const node = findAccountNodeByLoginAndClient(e.data.Login, currentNode.id, clientsTreeData);
        if (!node)
            return;
        setCurrentNode(node);
        setPendingScrollNodeKey(node.key);
    }
    const getStoredColumnWidth = (column) => {
        const widthsStorage = getWidthStorage();
        if (widthsStorage) {
            const columnWidth = widthsStorage[column];
            if (columnWidth)
                return columnWidth;
        }
        return getDefaultColumnWidth(column);
    }
    function getWidthStorage() {
        return JSON.parse(localStorage.getItem(localStorageKeys.accountsTableWidths) ?? "null");
    }
    const totalUnblocked = useMemo(() => {
        return data.reduce((sum, row) => {
            const devices = row.Devices?.Devices_;
            if (!devices)
                return sum;

            const unblocked = devices.filter((device) => !device.Blocked);
            return sum + unblocked.length;
        }, 0);
    }, [data]);

    const totalDevices = useMemo(() => {        
        return data.reduce((sum, row) => sum + (row.Devices?.Devices_?.length ?? 0), 0);
    }, [data]);


    const resizeHandle = (state) => {
        if (!state.column)
            return;

        const colId = state.column.colId;
        const colWidth = state.column.actualWidth;
        let widthsStorage = getWidthStorage();
        if (!widthsStorage)
            widthsStorage = {};

        widthsStorage[colId] = colWidth;

        localStorage.setItem(localStorageKeys.accountsTableWidths, JSON.stringify(widthsStorage));
    }
    const columns = useMemo<ColDef<IAccountsTableRow>[]>(
        () => [
            {
                headerName: "№",
                colId: 'rowNumber',
                width: getStoredColumnWidth(columnNames.rowNumber),
                editable: false,
                valueGetter: (props) => {
                    const row = props.node;
                    if (row && row.rowIndex != null && !isNaN(row.rowIndex) && !row.isRowPinned())
                        return row.rowIndex + 1;
                    else
                        return "";
                }
            },
            {
                field: 'Login',
                headerName: "Логин",
                width: getStoredColumnWidth(columnNames.login),
                editable: false
            },
            {
                field: 'Password',
                headerName: "Пароль",
                width: getStoredColumnWidth(columnNames.password),
                editable: false
            },
            {
                field: 'devicesCount',
                headerName: "Устройств всего",
                width: getStoredColumnWidth(columnNames.devicesCount),
                editable: false,
                valueGetter: (props) => {
                    const row = props.node;
                    const rowData = props.data;
                    if (row?.isRowPinned())
                        return props.data?.devicesCount;
                    else
                        return rowData?.Devices?.Devices_?.length ?? 0;
                }
            },
            {
                field: 'unblockedCount',
                headerName: "Устройств незабл-ых: ",
                width: getStoredColumnWidth(columnNames.unblockedCount),
                editable: false,
                valueGetter: (props) => {
                    const row = props.node;
                    const rowData = props.data;

                    if (row?.isRowPinned())
                        return rowData?.unblockedCount;
                    else {
                        const unblocked = rowData?.Devices?.Devices_?.filter((device) => !device.Blocked);
                        return unblocked?.length ?? 0;
                    }
                }
            }
        ],
        []
    )

    useEffect(() => {
        if (typeof window !== 'undefined' && currentNode) {
            setShowClientSettings(false);
            loadClient();
        }
    }, [currentNode]);

    function loadClient() {
        setIsLoading(true);
        centerClient.getClient(currentNode?.id ?? '')
            .then((res) => {
                const data = res.data;
                if (data)
                    successClientLoad(data);
            })
            .catch(() => void 0)
            .finally(() => setIsLoading(false));
    }
    const successClientLoad = (data: Client) => {
        const { Accounts, ...clientData } = data;
        if (Accounts)
            setData(Accounts);

        setClientAccounts(currentNode?.id ?? null, Accounts ?? []);
        setClient(data);
    }
    const tableRef = useRef<AgGridReact>(null);

    const pinnedBottomRowData = useMemo<any[]>(() => {
        return [
            {
                rowNumber: "",
                devicesCount: `Итого: ${totalDevices}`,
                unblockedCount: `Итого: ${totalUnblocked}`,
            },
        ];
    }, [totalUnblocked, totalDevices]);

    const getRowStyle = (row: RowClassParams) => {
        const pinned = row.node.isRowPinned();
        const color = pinned ? 'var(--bg-lighter)' : 'var(--bg)';
        const fontWeight = pinned ? 700 : 400;
        const style = {
            backgroundColor: color,
            fontWeight: fontWeight
        }
        return style;
    }

    return <>
        {
            isLoading || client == null ?
                <Skeleton width="100%" height="10rem"></Skeleton> :
                <ClientInfo client={client} setClient={setClient} />
        }          
        {
            useIsMobile() ? <></> :
            <div style={{ height: 'calc(100% - 11rem)', maxHeight: 'clamp(250px, calc(100vh - 12rem), 9999px)' }} >
                <BlickAgGrid
                    showRestoreColumnsButton={true}
                    loading={isLoading}
                    rowData={data}
                    ref={tableRef}
                    //theme={myAgReactTheme}
                    localeText={AG_GRID_LOCALE_RU}
                    getRowStyle={getRowStyle}
                    columnDefs={columns}
                    onColumnResized={resizeHandle}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onModelUpdated={(e) => { e.api.refreshCells() }}
                    pinnedBottomRowData={pinnedBottomRowData}
                />
            </div>
        }
    </>;
})

export default ClientView;
